import React from 'react';

import styled from 'styled-components/macro';

import { tokens } from '@olist/design-system-tokens';

const Wrapper = styled.button`
  background: transparent;
  border: 0;
  margin: 0 ${tokens.spacing[300]};
`;

export const OlistEmail = () => (
  <Wrapper>
    <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="42" height="42" rx="21" fill="#7DA2FF" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.875 12.25C24.29 12.25 26.25 14.21 26.25 16.625V17.5H29.75V29.75H12.25V17.5H15.75V16.625C15.75 14.21 17.71 12.25 20.125 12.25H21.875ZM20.125 14C18.6813 14 17.5 15.1813 17.5 16.625V17.5H24.5V16.625C24.5 15.1813 23.3188 14 21.875 14H20.125ZM28 28V19.25H26.25H15.75H14V28H28ZM20.1338 24.5C20.1338 24.4213 20.1425 24.3512 20.16 24.2812C19.6175 23.9838 19.25 23.4062 19.2588 22.75C19.2588 21.7875 20.0463 21 21.0088 21C21.9713 21 22.7588 21.7875 22.7588 22.75C22.7588 23.4062 22.4 23.9838 21.8575 24.2812C21.875 24.3512 21.8838 24.4213 21.8838 24.5V25.375C21.8838 25.8562 21.49 26.25 21.0088 26.25C20.5275 26.25 20.1338 25.8562 20.1338 25.375V24.5Z"
        fill="white"
      />
    </svg>
  </Wrapper>
);

export const OlistExpiredLink = () => (
  <Wrapper>
    <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="42" height="42" rx="21" fill="#FFCE4B" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.125 15.75H21.875L21.8903 22.75H20.1403L20.125 15.75ZM20.1403 24.5H21.8903V26.25H20.1403V24.5Z"
        fill="white"
      />
    </svg>
  </Wrapper>
);

export const OlistChecked = () => (
  <Wrapper>
    <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="42" height="42" rx="21" fill="#0DC78B" />
      <path
        d="M20.0266 25.8125L15.75 21.525L16.9859 20.2891L20.0266 23.3406L25.9 17.5L27.125 18.7469L20.0266 25.8125Z"
        fill="white"
      />
    </svg>
  </Wrapper>
);
